import { z } from 'zod';

export const investmentSchema = z.object({
  promptId: z.string().min(1),
  sent: z.number().int().min(0).max(10),
  predictedReturnPct: z.number().min(0).max(1),
  investorNote: z.string().max(280).optional()
});

export const returnSchema = z.object({
  roundId: z.string().min(1),
  trusteeReturn: z.number().int().min(0).max(30),
  trusteeNote: z.string().max(280).optional()
});

export const repairRequestSchema = z.object({
  roundId: z.string().min(1),
  requestType: z.enum(['acknowledge', 'apology', 'restitution', 'second_chance']),
  requestNote: z.string().max(280).optional()
});

export const repairResponseSchema = z.object({
  repairId: z.string().min(1),
  responseType: z.enum(['apology', 'extra_return', 'explanation', 'refusal']),
  responseNote: z.string().max(280).optional()
});
